import React from 'react';
import {Input} from "@chatui/core";
function Float(props) {

    const {value, setValue} = props;

    const onChange = (value) => {
        if (!isNaN(value)) // 只接收数字
            setValue(value)
    };

    return (
        <Input value={value} onChange={onChange}></Input>
    );
}

export default Float;